import apiClient from '@u/apiClient'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import GetImportController from '@/wayfinder/actions/App/Http/Controllers/Import/GetImportController'
import CreateImportController from '@/wayfinder/actions/App/Http/Controllers/Import/CreateImportController'
import UpdateImportController from '@/wayfinder/actions/App/Http/Controllers/Import/UpdateImportController'
import ListImportController from '@/wayfinder/actions/App/Http/Controllers/Import/ListImportController'
import DeleteImportController from '@/wayfinder/actions/App/Http/Controllers/Import/DeleteImportController'
import StartImportTaskController from '@/wayfinder/actions/App/Http/Controllers/Import/StartImportTaskController'
import CreateImportTaskController from '@/wayfinder/actions/App/Http/Controllers/Import/CreateImportTaskController'
import GetImportTaskController from '@/wayfinder/actions/App/Http/Controllers/Import/GetImportTaskController'
import GetImportTaskErrorsController from '@/wayfinder/actions/App/Http/Controllers/Import/GetImportTaskErrorsController'
import GetStatusTaskController from '@/wayfinder/actions/App/Http/Controllers/Import/GetStatusTaskController'
import DuplicateImportTaskController from '@/wayfinder/actions/App/Http/Controllers/Import/DuplicateImportTaskController'
import DeleteStatusTaskController from '@/wayfinder/actions/App/Http/Controllers/Import/DeleteStatusTaskController'
import UpdateImportTaskSyncAutoController from '@/wayfinder/actions/App/Http/Controllers/Import/UpdateImportTaskSyncAutoController'

export default {
  fetchNewImport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get(), {
          params: {
            model: 'Import'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getImport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetImportController.get({ import: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  createImport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateImportController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateImport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateImportController.put({ import: payload.id }), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchImportList({}) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ListImportController.get())
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteImport({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteImportController.delete({ import: payload.import_id }))
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  startImportTask({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          StartImportTaskController.get({
            import: payload.import_id,
            importTask: payload.import_task_id
          })
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  createImportTask({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateImportTaskController.post({ import: payload.import_id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getImportTask({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetImportTaskController.get({
            import: payload.import_id,
            importTask: payload.task_id
          })
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getImportTaskErrors({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetImportTaskErrorsController.get({
            import: payload.import_id,
            importTask: payload.task_id
          }),
          {
            params: {
              type: payload.type ?? null,
              types: payload.types ? payload.types.join(',') : null,
              page: payload.page ?? 1
            }
          }
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getImportTaskStatus({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetStatusTaskController.get({
            import: payload.import_id,
            importTask: payload.task_id
          })
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  duplicateImportTask({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DuplicateImportTaskController.get({
            import: payload.import_id,
            importTask: payload.task_id
          }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  /**
   * Turns the nightly V2 sync of an import task on or off. Resolves with the
   * updated task; a 422 (task the sync cannot run) is toasted by the client.
   */
  updateImportTaskSyncAuto(
    {},
    payload: { import_id: string; task_id: string; sync_auto: boolean }
  ) {
    return apiClient
      .route(
        UpdateImportTaskSyncAutoController.patch({
          import: payload.import_id,
          importTask: payload.task_id
        }),
        { sync_auto: payload.sync_auto }
      )
      .then((response) => response.data.import_task)
  },

  deleteImportTask({}, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteStatusTaskController.delete({
            import: payload.import_id,
            importTask: payload.task_id
          })
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
